const schema = {
    types: {
        id: 'types',
        label: 'Tipo de Guia',
        type: 'select',
        lookup: 'Contrato(s)',
        required: true,
    },
    from: {
        id: 'from',
        label: 'De',
        placeholder: '',
        type: 'date',
        required: true,
    },
    at: {
        id: 'at',
        label: 'Até',
        placeholder: '',
        type: 'date',
        required: true,
    },
    guidance: {
        id: 'guidance',
        label: 'N° da guia',
        placeholder: '',
        type: 'text',
    },
};

export default schema;
